import SalishConfig from "./Salish/config";
import WestBankConfig from "./WestBank/config";
import RedLakeConfig from "./RedLake/config";
import FortBelknapConfig from "./FortBelknap/config";
import PokagonConfig from "./Pokagon/config";
import DenaakkeConfig from "./Denaakke/config";

const configs = {
  Salish: SalishConfig,
  WestBank: WestBankConfig,
  RedLake: RedLakeConfig,
  FortBelknap: FortBelknapConfig,
  Pokagon: PokagonConfig,
  Denaakke: DenaakkeConfig,
};

const community = process.env.REACT_APP_COMMUNITY;

if (!community || !configs[community]) {
  throw new Error(
    `Invalid or missing REACT_APP_COMMUNITY: "${community}". ` +
      `Valid values: ${Object.keys(configs).join(", ")}`
  );
}

const config = configs[community];

export default config;

export const {
  AppName,
  Language,
  Tribe,
  FirebaseConfig,
  SecondaryFirebaseConfig,
  FilePath,
  NacaApiUrl,
  NacaCommunityId,
  SheetsToPull,
  ParamsToFindGame,
  BottomColor,
  NumberDataCategory,
  VersionNumber,
  Credits,
  PossibleGames,
  ShowStorybookCorner,
  ShowLinkButton,
  Link,
  FeedbackLink,
  hasLocationSelection,
  dialectStructure,
} = config;
